export var handlePress = function (_a) {
  var onPress = _a.onPress,
    value = _a.value,
    onValueChange = _a.onValueChange;
  return onValueChange ? onValueChange(value) : onPress === null || onPress === void 0 ? void 0 : onPress();
};
export var isChecked = function (_a) {
  var value = _a.value,
    status = _a.status,
    contextValue = _a.contextValue;
  if (contextValue) {
    return contextValue === value ? "checked" : "unchecked";
  } else {
    return status;
  }
};